module.exports = __webpack_public_path__ + "img/save.1731195f.svg";